"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scopeList = exports.setModuleSelection = exports.getModuleCustomScope = exports.getModuleSelection = exports.getModuleList = exports.ModulePermissions = exports.ModuleList = exports.ScopeSelectionType = exports.ScopeType = exports.Module = exports.ModuleType = void 0;
var ModuleType;
(function (ModuleType) {
  ModuleType["Global"] = "global";
  ModuleType["Event"] = "event";
  ModuleType["Other"] = "other";
})(ModuleType = exports.ModuleType || (exports.ModuleType = {}));
var Module;
(function (Module) {
  Module["CRM"] = "crm";
  Module["Document"] = "document";
  Module["EmailCampaign"] = "email_campaign";
  Module["Integration"] = "integration";
  Module["Financial"] = "financial";
  Module["FieldManager"] = "field_manager";
  Module["Report"] = "report";
  Module["RoomManagement"] = "room_management";
  Module["Theme"] = "theme";
  Module["Project"] = "project";
  Module["Event"] = "event";
  Module["FieldManagerLocal"] = "field_manager_local";
  Module["Content"] = "content";
  Module["DocumentLocal"] = "document_local";
  Module["Activity"] = "activity";
  Module["WorkflowLocal"] = "workflow_local";
  Module["Participant"] = "participant";
  Module["ReportLocal"] = "report_local";
  Module["FinancialLocal"] = "financial_local";
  Module["RoomManagementLocal"] = "room_management_local";
  Module["Azavista2"] = "azavista2";
  Module["GenericTeam"] = "generic_team";
  Module["EventApp"] = "event_app";
  Module["EventAppLocal"] = "event_app_local";
  Module["Global"] = "global";
  Module["EventWorkflow"] = "event_workflow";
  Module["UserManagement"] = "user_management";
})(Module = exports.Module || (exports.Module = {}));
var ScopeType;
(function (ScopeType) {
  ScopeType["Create"] = "create";
  ScopeType["Read"] = "read";
  ScopeType["Update"] = "update";
  ScopeType["Delete"] = "delete";
  ScopeType["Allow"] = "allow";
})(ScopeType = exports.ScopeType || (exports.ScopeType = {}));
var ScopeSelectionType;
(function (ScopeSelectionType) {
  ScopeSelectionType["All"] = "all";
  ScopeSelectionType["ReadOnly"] = "readonly";
  ScopeSelectionType["Disabled"] = "disabled";
  ScopeSelectionType["Custom"] = "custom";
})(ScopeSelectionType = exports.ScopeSelectionType || (exports.ScopeSelectionType = {}));
exports.ModuleList = [{
  module_type: ModuleType.Global,
  name: Module.CRM,
  label: 'MODULE_CRM'
}, {
  module_type: ModuleType.Global,
  name: Module.Document,
  label: 'MODULE_DOCUMENT'
}, {
  module_type: ModuleType.Global,
  name: Module.EmailCampaign,
  label: 'MODULE_EMAIL_CAMPAIGN'
}, {
  module_type: ModuleType.Global,
  name: Module.Integration,
  label: 'MODULE_INTEGRATION'
}, {
  module_type: ModuleType.Global,
  name: Module.Financial,
  label: 'MODULE_FINANCIAL'
}, {
  module_type: ModuleType.Global,
  name: Module.FieldManager,
  label: 'MODULE_FIELD_MANAGER'
}, {
  module_type: ModuleType.Global,
  name: Module.Report,
  label: 'MODULE_REPORT'
}, {
  module_type: ModuleType.Global,
  name: Module.RoomManagement,
  label: 'MODULE_ROOM_MANAGEMENT'
}, {
  module_type: ModuleType.Global,
  name: Module.Theme,
  label: 'MODULE_THEME'
}, {
  module_type: ModuleType.Global,
  name: Module.Project,
  label: 'MODULE_PROJECT'
}, {
  module_type: ModuleType.Event,
  name: Module.Event,
  label: 'MODULE_EVENT'
}, {
  module_type: ModuleType.Global,
  name: Module.EventApp,
  label: 'MODULE_EVENT_APP'
}, {
  module_type: ModuleType.Event,
  name: Module.EventAppLocal,
  label: 'MODULE_EVENT_APP_LOCAL'
}, {
  module_type: ModuleType.Event,
  name: Module.FieldManagerLocal,
  label: 'MODULE_FIELD_MANAGER_LOCAL'
}, {
  module_type: ModuleType.Event,
  name: Module.Content,
  label: 'MODULE_CONTENT'
}, {
  module_type: ModuleType.Event,
  name: Module.DocumentLocal,
  label: 'MODULE_DOCUMENT_LOCAL'
}, {
  module_type: ModuleType.Event,
  name: Module.Activity,
  label: 'MODULE_ACTIVITY'
}, {
  module_type: ModuleType.Event,
  name: Module.WorkflowLocal,
  label: 'MODULE_WORKFLOW_LOCAL'
}, {
  module_type: ModuleType.Event,
  name: Module.Participant,
  label: 'MODULE_PARTICIPANT'
}, {
  module_type: ModuleType.Event,
  name: Module.ReportLocal,
  label: 'MODULE_REPORT_LOCAL'
}, {
  module_type: ModuleType.Event,
  name: Module.RoomManagementLocal,
  label: 'MODULE_ROOM_MANAGEMENT_LOCAL'
}, {
  module_type: ModuleType.Other,
  name: Module.Azavista2,
  label: 'MODULE_AZAVISTA2'
}, {
  module_type: ModuleType.Other,
  name: Module.GenericTeam,
  label: 'MODULE_GENERIC_TEAM'
}, {
  module_type: ModuleType.Other,
  name: Module.Global,
  label: 'MODULE_GLOBAL'
}, {
  module_type: ModuleType.Other,
  name: Module.EventWorkflow,
  label: 'MODULE_EVENT_WORKFLOW'
}, {
  module_type: ModuleType.Global,
  name: Module.UserManagement,
  label: 'MODULE_USER_MANAGEMENT'
}];
exports.ModulePermissions = [{
  name: Module.UserManagement,
  permissions: [{
    label: 'PERMISSION_USER_MANAGEMENT_USER',
    scopes: {
      [ScopeType.Create]: "umu:c" /* scope.User.Create */,
      [ScopeType.Read]: "umu:r" /* scope.User.Read */,
      [ScopeType.Update]: "umu:u" /* scope.User.Update */,
      [ScopeType.Delete]: "umu:d" /* scope.User.Delete */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_USER_ASSIGN',
    scopes: {
      [ScopeType.Allow]: "umu:a" /* scope.User.Assign */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_TEAM',
    scopes: {
      [ScopeType.Create]: "umt:c" /* scope.Team.Create */,
      [ScopeType.Read]: "umt:r" /* scope.Team.Read */,
      [ScopeType.Update]: "umt:u" /* scope.Team.Update */,
      [ScopeType.Delete]: "umt:d" /* scope.Team.Delete */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_TEAM_ASSIGN',
    scopes: {
      [ScopeType.Allow]: "umt:a" /* scope.Team.Assign */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_ROLE',
    scopes: {
      [ScopeType.Read]: "umr:r" /* scope.Role.Read */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_ROLE_ASSIGN',
    scopes: {
      [ScopeType.Allow]: "umr:a" /* scope.Role.Assign */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_APICLIENT',
    scopes: {
      [ScopeType.Create]: "uma:c" /* scope.ApiClient.Create */,
      [ScopeType.Read]: "uma:r" /* scope.ApiClient.Read */,
      [ScopeType.Update]: "uma:u" /* scope.ApiClient.Update */,
      [ScopeType.Delete]: "uma:d" /* scope.ApiClient.Delete */
    }
  }, {
    label: 'PERMISSION_USER_MANAGEMENT_APICLIENT_ASSIGN',
    scopes: {
      [ScopeType.Allow]: "uma:a" /* scope.ApiClient.Assign */
    }
  }]
}, {
  name: Module.CRM,
  permissions: [{
    label: 'PERMISSION_CRM',
    scopes: {
      [ScopeType.Create]: "crm:c" /* scope.CRM.Create */,
      [ScopeType.Read]: "crm:r" /* scope.CRM.Read */,
      [ScopeType.Update]: "crm:u" /* scope.CRM.Update */,
      [ScopeType.Delete]: "crm:d" /* scope.CRM.Delete */
    }
  }, {
    label: 'PERMISSION_CRM_EXPORT',
    scopes: {
      [ScopeType.Allow]: "crm:x" /* scope.CRM.ExportSpreadsheet */
    }
  }, {
    label: 'PERMISSION_CRM_VIEW',
    scopes: {
      [ScopeType.Allow]: "crm:v" /* scope.CRM.View */
    }
  }, {
    label: 'PERMISSION_CRM_EMAIL_PUBLISH_TEMPLATE',
    scopes: {
      [ScopeType.Allow]: "ctp:p" /* scope.CRMEmail.PublishTemplate */
    }
  }, {
    label: 'PERMISSION_CRM_EMAIL_SEND',
    scopes: {
      [ScopeType.Allow]: "mailc:s" /* scope.CRMEmail.SendMail */
    }
  }, {
    label: 'PERMISSION_PROFILE_PAGE',
    scopes: {
      [ScopeType.Create]: "prf:c" /* scope.ProfilePage.Create */,
      [ScopeType.Read]: "prf:r" /* scope.ProfilePage.Read */,
      [ScopeType.Update]: "prf:u" /* scope.ProfilePage.Update */,
      [ScopeType.Delete]: "prf:d" /* scope.ProfilePage.Delete */
    }
  }]
}, {
  name: Module.Document,
  permissions: [{
    label: 'PERMISSION_CONTACT_ASSET',
    scopes: {
      [ScopeType.Create]: "asc:c" /* scope.CRMEmail.CreateAsset */,
      [ScopeType.Read]: "asc:r" /* scope.CRMEmail.ReadAsset */,
      [ScopeType.Update]: "asc:u" /* scope.CRMEmail.UpdateAsset */,
      [ScopeType.Delete]: "asc:d" /* scope.CRMEmail.DeleteAsset */
    }
  }]
}, {
  name: Module.EmailCampaign,
  permissions: [{
    label: 'PERMISSION_CONTACT_CAMPAIGN',
    scopes: {
      [ScopeType.Create]: "cmc:c" /* scope.CRMEmail.CreateCampaign */,
      [ScopeType.Read]: "cmc:r" /* scope.CRMEmail.ReadCampaign */,
      [ScopeType.Update]: "cmc:u" /* scope.CRMEmail.UpdateCampaign */,
      [ScopeType.Delete]: "cmc:d" /* scope.CRMEmail.DeleteCampaign */
    }
  }, {
    label: 'PERMISSION_CONTACT_CAMPAIGN_TYPE',
    scopes: {
      [ScopeType.Create]: "cmt:c" /* scope.CRMEmail.CreateCampaignType */,
      [ScopeType.Read]: "cmt:r" /* scope.CRMEmail.ReadCampaignType */,
      [ScopeType.Update]: "cmt:u" /* scope.CRMEmail.UpdateCampaignType */,
      [ScopeType.Delete]: "cmt:d" /* scope.CRMEmail.DeleteCampaignType */
    }
  }, {
    label: 'PERMISSION_CONTACT_TEMPLATE',
    scopes: {
      [ScopeType.Create]: "ctp:c" /* scope.CRMEmail.CreateTemplate */,
      [ScopeType.Read]: "ctp:r" /* scope.CRMEmail.ReadTemplate */,
      [ScopeType.Update]: "ctp:u" /* scope.CRMEmail.UpdateTemplate */,
      [ScopeType.Delete]: "ctp:d" /* scope.CRMEmail.DeleteTemplate */
    }
  }, {
    label: 'PERMISSION_EMAIL_TEMPLATE',
    scopes: {
      [ScopeType.Create]: "evetp:c" /* scope.GlobalEventEmailTemplate.CreateTemplate */,
      [ScopeType.Read]: "evetp:r" /* scope.GlobalEventEmailTemplate.ReadTemplate */,
      [ScopeType.Update]: "evetp:u" /* scope.GlobalEventEmailTemplate.UpdateTemplate */,
      [ScopeType.Delete]: "evetp:d" /* scope.GlobalEventEmailTemplate.DeleteTemplate */
    }
  }, {
    label: 'PERMISSION_EMAIL_TEMPLATE_PUBLISH',
    scopes: {
      [ScopeType.Allow]: "evetp:p" /* scope.GlobalEventEmailTemplate.PublishTemplate */
    }
  }, {
    label: 'PERMISSION_EMAIL_ASSET',
    scopes: {
      [ScopeType.Create]: "evasc:c" /* scope.GlobalEventEmailTemplate.CreateAsset */,
      [ScopeType.Read]: "evasc:r" /* scope.GlobalEventEmailTemplate.ReadAsset */,
      [ScopeType.Update]: "evasc:u" /* scope.GlobalEventEmailTemplate.UpdateAsset */,
      [ScopeType.Delete]: "evasc:d" /* scope.GlobalEventEmailTemplate.DeleteAsset */
    }
  }, {
    label: 'PERMISSION_SYSTEM_EMAIL',
    scopes: {
      [ScopeType.Create]: "se:c" /* scope.SystemEmail.Create */,
      [ScopeType.Read]: "se:r" /* scope.SystemEmail.Read */,
      [ScopeType.Update]: "se:u" /* scope.SystemEmail.Update */,
      [ScopeType.Delete]: "se:d" /* scope.SystemEmail.Delete */
    }
  }]
}, {
  name: Module.Integration,
  permissions: [{
    label: 'PERMISSION_INTEGRATION',
    scopes: {
      [ScopeType.Create]: "int:c" /* scope.Integration.Create */,
      [ScopeType.Read]: "int:r" /* scope.Integration.Read */,
      [ScopeType.Update]: "int:u" /* scope.Integration.Update */,
      [ScopeType.Delete]: "int:d" /* scope.Integration.Delete */
    }
  }, {
    label: 'PERMISSION_GLOBAL_EVENT_PROCESS',
    scopes: {
      [ScopeType.Create]: "gevtp:c" /* scope.GlobalEventProcess.Create */,
      [ScopeType.Read]: "gevtp:r" /* scope.GlobalEventProcess.Read */,
      [ScopeType.Update]: "gevtp:ul" /* scope.GlobalEventProcess.Update */,
      [ScopeType.Delete]: "gevtp:d" /* scope.GlobalEventProcess.Delete */
    }
  }, {
    label: 'PERMISSION_GLOBAL_EVENT_PROCESS_UPDATE_AND_CONTROL',
    scopes: {
      [ScopeType.Allow]: "gevtp:u" /* scope.GlobalEventProcess.UpdateAndControl */
    }
  }, {
    label: 'PERMISSION_GLOBAL_EVENT_PROCESS_PAUSE',
    scopes: {
      [ScopeType.Allow]: "gevtp:p" /* scope.GlobalEventProcess.Pause */
    }
  }, {
    label: 'PERMISSION_GLOBAL_EVENT_PROCESS_INTERRUPT',
    scopes: {
      [ScopeType.Allow]: "gevtp:i" /* scope.GlobalEventProcess.Interrupt */
    }
  }, {
    label: 'PERMISSION_GLOBAL_PARTICIPANT_PROCESS',
    scopes: {
      [ScopeType.Create]: "gprc:c" /* scope.GlobalParticipantProcess.Create */,
      [ScopeType.Read]: "gprc:r" /* scope.GlobalParticipantProcess.Read */,
      [ScopeType.Update]: "gprc:ul" /* scope.GlobalParticipantProcess.Update */,
      [ScopeType.Delete]: "gprc:d" /* scope.GlobalParticipantProcess.Delete */
    }
  }, {
    label: 'PERMISSION_GLOBAL_PARTICIPANT_PROCESS_UPDATE_AND_CONTROL',
    scopes: {
      [ScopeType.Allow]: "gprc:u" /* scope.GlobalParticipantProcess.UpdateAndControl */
    }
  }, {
    label: 'PERMISSION_GLOBAL_PARTICIPANT_PROCESS_PAUSE',
    scopes: {
      [ScopeType.Allow]: "gprc:p" /* scope.GlobalParticipantProcess.Pause */
    }
  }, {
    label: 'PERMISSION_GLOBAL_PARTICIPANT_PROCESS_INTERRUPT',
    scopes: {
      [ScopeType.Allow]: "gprc:i" /* scope.GlobalParticipantProcess.Interrupt */
    }
  }, {
    label: 'PERMISSION_CONTACT_PROCESS',
    scopes: {
      [ScopeType.Create]: "cp:c" /* scope.ContactProcess.Create */,
      [ScopeType.Read]: "cp:r" /* scope.ContactProcess.Read */,
      [ScopeType.Update]: "cp:ul" /* scope.ContactProcess.Update */,
      [ScopeType.Delete]: "cp:d" /* scope.ContactProcess.Delete */
    }
  }, {
    label: 'PERMISSION_CONTACT_PROCESS_UPDATE_AND_CONTROL',
    scopes: {
      [ScopeType.Allow]: "cp:u" /* scope.ContactProcess.UpdateAndControl */
    }
  }, {
    label: 'PERMISSION_CONTACT_PROCESS_PAUSE',
    scopes: {
      [ScopeType.Allow]: "cp:p" /* scope.ContactProcess.Pause */
    }
  }, {
    label: 'PERMISSION_CONTACT_PROCESS_INTERRUPT',
    scopes: {
      [ScopeType.Allow]: "cp:i" /* scope.ContactProcess.Interrupt */
    }
  }, {
    label: 'PERMISSION_ORGANIZATION_PROCESS',
    scopes: {
      [ScopeType.Create]: "op:c" /* scope.OrganizationProcess.Create */,
      [ScopeType.Read]: "op:r" /* scope.OrganizationProcess.Read */,
      [ScopeType.Update]: "op:ul" /* scope.OrganizationProcess.Update */,
      [ScopeType.Delete]: "op:d" /* scope.OrganizationProcess.Delete */
    }
  }, {
    label: 'PERMISSION_ORGANIZATION_PROCESS_UPDATE_AND_CONTROL',
    scopes: {
      [ScopeType.Allow]: "op:u" /* scope.OrganizationProcess.UpdateAndControl */
    }
  }, {
    label: 'PERMISSION_ORGANIZATION_PROCESS_PAUSE',
    scopes: {
      [ScopeType.Allow]: "op:p" /* scope.OrganizationProcess.Pause */
    }
  }, {
    label: 'PERMISSION_ORGANIZATION_PROCESS_INTERRUPT',
    scopes: {
      [ScopeType.Allow]: "op:i" /* scope.OrganizationProcess.Interrupt */
    }
  }]
}, {
  name: Module.Financial,
  permissions: [{
    label: 'PERMISSION_FINANCIAL',
    scopes: {
      [ScopeType.Create]: "fin:c" /* scope.Financial.Create */,
      [ScopeType.Read]: "fin:r" /* scope.Financial.Read */,
      [ScopeType.Update]: "fin:u" /* scope.Financial.Update */,
      [ScopeType.Delete]: "fin:d" /* scope.Financial.Delete */
    }
  }]
}, {
  name: Module.FieldManager,
  permissions: [{
    label: 'PERMISSION_ORGANIZATION_FIELD',
    scopes: {
      [ScopeType.Create]: "of:c" /* scope.OrganizationField.Create */,
      [ScopeType.Read]: "of:r" /* scope.OrganizationField.Read */,
      [ScopeType.Update]: "of:u" /* scope.OrganizationField.Update */,
      [ScopeType.Delete]: "of:d" /* scope.OrganizationField.Delete */
    }
  }, {
    label: 'PERMISSION_CONTACT_FIELD',
    scopes: {
      [ScopeType.Create]: "cf:c" /* scope.ContactField.Create */,
      [ScopeType.Read]: "cf:r" /* scope.ContactField.Read */,
      [ScopeType.Update]: "cf:u" /* scope.ContactField.Update */,
      [ScopeType.Delete]: "cf:d" /* scope.ContactField.Delete */
    }
  }, {
    label: 'PERMISSION_EVENT_FIELD',
    scopes: {
      [ScopeType.Create]: "ef:c" /* scope.EventField.Create */,
      [ScopeType.Read]: "ef:r" /* scope.EventField.Read */,
      [ScopeType.Update]: "ef:u" /* scope.EventField.Update */,
      [ScopeType.Delete]: "ef:d" /* scope.EventField.Delete */
    }
  }]
}, {
  name: Module.Report,
  permissions: [{
    label: 'PERMISSION_REPORT',
    scopes: {
      [ScopeType.Create]: "rprt:c" /* scope.Report.Create */,
      [ScopeType.Read]: "rprt:r" /* scope.Report.Read */,
      [ScopeType.Update]: "rprt:u" /* scope.Report.Update */,
      [ScopeType.Delete]: "rprt:d" /* scope.Report.Delete */
    }
  }]
}, {
  name: Module.RoomManagement,
  permissions: [{
    label: 'PERMISSION_ROOM_MANAGEMENT',
    scopes: {
      [ScopeType.Create]: "rmm:c" /* scope.RoomManagement.Create */,
      [ScopeType.Read]: "rmm:r" /* scope.RoomManagement.Read */,
      [ScopeType.Update]: "rmm:u" /* scope.RoomManagement.Update */,
      [ScopeType.Delete]: "rmm:d" /* scope.RoomManagement.Delete */
    }
  }, {
    label: 'PERMISSION_ROOM_MANAGEMENT_APPROVE',
    scopes: {
      [ScopeType.Allow]: "rmm:ab" /* scope.RoomManagement.ApproveBooking */
    }
  }]
}, {
  name: Module.Theme,
  permissions: [{
    label: 'PERMISSION_THEME',
    scopes: {
      [ScopeType.Create]: "thm:c" /* scope.Theme.Create */,
      [ScopeType.Read]: "thm:r" /* scope.Theme.Read */,
      [ScopeType.Update]: "thm:u" /* scope.Theme.Update */,
      [ScopeType.Delete]: "thm:d" /* scope.Theme.Delete */
    }
  }, {
    label: 'PERMISSION_THEME_ASSET',
    scopes: {
      [ScopeType.Create]: "att:c" /* scope.Theme.CreateAsset */,
      [ScopeType.Read]: "att:r" /* scope.Theme.ReadAsset */,
      [ScopeType.Update]: "att:u" /* scope.Theme.UpdateAsset */,
      [ScopeType.Delete]: "att:d" /* scope.Theme.DeleteAsset */
    }
  }]
}, {
  name: Module.Project,
  permissions: [{
    label: 'PERMISSION_PROJECT',
    scopes: {
      [ScopeType.Create]: "prj:c" /* scope.Project.Create */,
      [ScopeType.Read]: "prj:r" /* scope.Project.Read */,
      [ScopeType.Update]: "prj:u" /* scope.Project.Update */,
      [ScopeType.Delete]: "prj:d" /* scope.Project.Delete */
    }
  }, {
    label: 'PERMISSION_TASK',
    scopes: {
      [ScopeType.Create]: "tsk:c" /* scope.Task.Create */,
      [ScopeType.Read]: "tsk:r" /* scope.Task.Read */,
      [ScopeType.Update]: "tsk:u" /* scope.Task.Update */,
      [ScopeType.Delete]: "tsk:d" /* scope.Task.Delete */
    }
  }]
}, {
  name: Module.Event,
  permissions: [{
    label: 'PERMISSION_EVENT',
    scopes: {
      [ScopeType.Create]: "evt:c" /* scope.Event.Create */,
      [ScopeType.Read]: "evt:r" /* scope.Event.Read */,
      [ScopeType.Update]: "evt:u" /* scope.Event.Update */,
      [ScopeType.Delete]: "evt:d" /* scope.Event.Delete */
    }
  }, {
    label: 'PERMISSION_EVENT_LIST',
    scopes: {
      [ScopeType.Allow]: "evt:l" /* scope.Event.List */
    }
  }, {
    label: 'PERMISSION_EVENT_COPY',
    scopes: {
      [ScopeType.Allow]: "evt:cp" /* scope.Event.Copy */
    }
  }, {
    label: 'PERMISSION_EVENT_CANCEL',
    scopes: {
      [ScopeType.Allow]: "evt:x" /* scope.Event.Cancel */
    }
  }, {
    label: 'PERMISSION_EVENT_UPDATE_SETTINGS',
    scopes: {
      [ScopeType.Allow]: "evt:s" /* scope.Event.UpdateSettings */
    }
  }, {
    label: 'PERMISSION_EVENT_VIEW',
    scopes: {
      [ScopeType.Allow]: "evt:v" /* scope.Event.View */
    }
  }, {
    label: 'PERMISSION_EVENT_ADMIN',
    scopes: {
      [ScopeType.Allow]: "evt:a" /* scope.Event.EventAdmin */
    }
  }, {
    label: 'PERMISSION_EVENT_SERIES',
    scopes: {
      [ScopeType.Create]: "ser:c" /* scope.EventSeries.Create */,
      [ScopeType.Read]: "ser:r" /* scope.EventSeries.Read */,
      [ScopeType.Update]: "ser:u" /* scope.EventSeries.Update */,
      [ScopeType.Delete]: "ser:d" /* scope.EventSeries.Delete */
    }
  }, {
    label: 'PERMISSION_EVENT_SERIES_PUBLISH',
    scopes: {
      [ScopeType.Allow]: "ser:p" /* scope.EventSeries.Publish */
    }
  }]
}, {
  name: Module.FieldManagerLocal,
  permissions: [{
    label: 'PERMISSION_EVENT_FIELD_LOCAL',
    scopes: {
      [ScopeType.Create]: "lef:c" /* scope.EventField.CreateLocal */,
      [ScopeType.Update]: "lef:u" /* scope.EventField.UpdateLocal */,
      [ScopeType.Delete]: "lef:d" /* scope.EventField.DeleteLocal */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_FIELD',
    scopes: {
      [ScopeType.Create]: "epf:c" /* scope.ParticipantField.Create */,
      [ScopeType.Read]: "epf:r" /* scope.ParticipantField.Read */,
      [ScopeType.Update]: "epf:u" /* scope.ParticipantField.Update */,
      [ScopeType.Delete]: "epf:d" /* scope.ParticipantField.Delete */
    }
  }]
}, {
  name: Module.Content,
  permissions: [{
    label: 'PERMISSION_EVENT_PAGE',
    scopes: {
      [ScopeType.Create]: "evp:c" /* scope.EventPage.Create */,
      [ScopeType.Read]: "evp:r" /* scope.EventPage.Read */,
      [ScopeType.Update]: "evp:u" /* scope.EventPage.Update */,
      [ScopeType.Delete]: "evp:d" /* scope.EventPage.Delete */
    }
  }, {
    label: 'PERMISSION_EVENT_PAGE_PUBLISH',
    scopes: {
      [ScopeType.Allow]: "evp:p" /* scope.EventPage.Publish */
    }
  }, {
    label: 'PERMISSION_EVENT_EMAIL_TEMPLATE',
    scopes: {
      [ScopeType.Create]: "etp:c" /* scope.EventEmail.CreateTemplate */,
      [ScopeType.Read]: "etp:r" /* scope.EventEmail.ReadTemplate */,
      [ScopeType.Update]: "etp:u" /* scope.EventEmail.UpdateTemplate */,
      [ScopeType.Delete]: "etp:d" /* scope.EventEmail.DeleteTemplate */
    }
  }, {
    label: 'PERMISSION_EVENT_EMAIL_TEMPLATE_PUBLISH',
    scopes: {
      [ScopeType.Allow]: "etp:p" /* scope.EventEmail.PublishTemplate */
    }
  }, {
    label: 'PERMISSION_EVENT_EMAIL_CAMPAIGN',
    scopes: {
      [ScopeType.Create]: "cmp:c" /* scope.EventEmail.CreateCampaign */,
      [ScopeType.Read]: "cmp:r" /* scope.EventEmail.ReadCampaign */,
      [ScopeType.Update]: "cmp:u" /* scope.EventEmail.UpdateCampaign */,
      [ScopeType.Delete]: "cmp:d" /* scope.EventEmail.DeleteCampaign */
    }
  }, {
    label: 'PERMISSION_EVENT_EMAIL_SEND',
    scopes: {
      [ScopeType.Allow]: "mail:s" /* scope.EventEmail.SendMail */
    }
  }, {
    label: 'PERMISSION_EVENT_EMAIL_ASSET',
    scopes: {
      [ScopeType.Create]: "asc:c" /* scope.EventEmail.CreateAsset */,
      [ScopeType.Read]: "asc:r" /* scope.EventEmail.ReadAsset */,
      [ScopeType.Update]: "asc:u" /* scope.EventEmail.UpdateAsset */,
      [ScopeType.Delete]: "asc:d" /* scope.EventEmail.DeleteAsset */
    }
  }]
}, {
  name: Module.DocumentLocal,
  permissions: [{
    label: 'PERMISSION_EVENT_ASSET',
    scopes: {
      [ScopeType.Create]: "ast:c" /* scope.EventPage.CreateAsset */,
      [ScopeType.Read]: "ast:r" /* scope.EventPage.ReadAsset */,
      [ScopeType.Update]: "ast:u" /* scope.EventPage.UpdateAsset */,
      [ScopeType.Delete]: "ast:d" /* scope.EventPage.DeleteAsset */
    }
  }]
}, {
  name: Module.Activity,
  permissions: [{
    label: 'PERMISSION_ACTIVITY',
    scopes: {
      [ScopeType.Create]: "act:c" /* scope.Activity.Create */,
      [ScopeType.Read]: "act:r" /* scope.Activity.Read */,
      [ScopeType.Update]: "act:u" /* scope.Activity.Update */,
      [ScopeType.Delete]: "act:d" /* scope.Activity.Delete */
    }
  }, {
    label: 'PERMISSION_ENGAGEMENT_APP_READ_SETTINGS',
    scopes: {
      [ScopeType.Allow]: "eng:r" /* scope.EngagementApp.ReadSettings */
    }
  }, {
    label: 'PERMISSION_ENGAGEMENT_APP_UPDATE_SETTINGS',
    scopes: {
      [ScopeType.Allow]: "eng:u" /* scope.EngagementApp.UpdateSettings */
    }
  }]
}, {
  name: Module.EventAppLocal,
  permissions: [{
    label: 'PERMISSION_EVENT_EVENT_APP',
    scopes: {
      [ScopeType.Create]: "eeva:c" /* scope.EventEventApp.Create */,
      [ScopeType.Read]: "eeva:r" /* scope.EventEventApp.Read */,
      [ScopeType.Update]: "eeva:u" /* scope.EventEventApp.Update */,
      [ScopeType.Delete]: "eeva:d" /* scope.EventEventApp.Delete */
    }
  }]
}, {
  name: Module.WorkflowLocal,
  permissions: [{
    label: 'PERMISSION_STAGE',
    scopes: {
      [ScopeType.Create]: "stg:c" /* scope.Stage.Create */,
      [ScopeType.Read]: "stg:r" /* scope.Stage.Read */,
      [ScopeType.Update]: "stg:u" /* scope.Stage.Update */,
      [ScopeType.Delete]: "stg:d" /* scope.Stage.Delete */
    }
  }, {
    label: 'PERMISSION_EVENT_PROCESS',
    scopes: {
      [ScopeType.Create]: "evtp:c" /* scope.EventProcess.Create */,
      [ScopeType.Read]: "evtp:r" /* scope.EventProcess.Read */,
      [ScopeType.Update]: "evtp:ul" /* scope.EventProcess.Update */,
      [ScopeType.Delete]: "evtp:d" /* scope.EventProcess.Delete */
    }
  }, {
    label: 'PERMISSION_EVENT_PROCESS_UPDATE_AND_CONTROL',
    scopes: {
      [ScopeType.Allow]: "evtp:u" /* scope.EventProcess.UpdateAndControl */
    }
  }, {
    label: 'PERMISSION_EVENT_PROCESS_PAUSE',
    scopes: {
      [ScopeType.Allow]: "evtp:p" /* scope.EventProcess.Pause */
    }
  }, {
    label: 'PERMISSION_EVENT_PROCESS_INTERRUPT',
    scopes: {
      [ScopeType.Allow]: "evtp:i" /* scope.EventProcess.Interrupt */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_PROCESS',
    scopes: {
      [ScopeType.Create]: "prc:c" /* scope.ParticipantProcess.Create */,
      [ScopeType.Read]: "prc:r" /* scope.ParticipantProcess.Read */,
      [ScopeType.Update]: "prc:ul" /* scope.ParticipantProcess.Update */,
      [ScopeType.Delete]: "prc:d" /* scope.ParticipantProcess.Delete */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_PROCESS_UPDATE_AND_CONTROL',
    scopes: {
      [ScopeType.Allow]: "prc:u" /* scope.ParticipantProcess.UpdateAndControl */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_PROCESS_PAUSE',
    scopes: {
      [ScopeType.Allow]: "prc:p" /* scope.ParticipantProcess.Pause */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_PROCESS_INTERRUPT',
    scopes: {
      [ScopeType.Allow]: "prc:i" /* scope.ParticipantProcess.Interrupt */
    }
  }]
}, {
  name: Module.Participant,
  permissions: [{
    label: 'PERMISSION_PARTICIPANT',
    scopes: {
      [ScopeType.Create]: "par:c" /* scope.Participant.Create */,
      [ScopeType.Read]: "par:v" /* scope.Participant.View */,
      [ScopeType.Update]: "par:u" /* scope.Participant.Update */,
      [ScopeType.Delete]: "par:d" /* scope.Participant.Delete */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_EXPORT',
    scopes: {
      [ScopeType.Allow]: "par:x" /* scope.Participant.ExportSpreadsheet */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_IMPERSONATE',
    scopes: {
      [ScopeType.Allow]: "par:i" /* scope.Participant.Impersonate */
    }
  }, {
    label: 'PERMISSION_PARTICIPANT_MANAGE_TEAM',
    scopes: {
      [ScopeType.Allow]: "par:t" /* scope.Participant.ManageTeam */
    }
  }]
}, {
  name: Module.ReportLocal,
  permissions: [{
    label: 'PERMISSION_REPORT_LOCAL',
    scopes: {
      [ScopeType.Create]: "rprtl:c" /* scope.Report.CreateLocal */,
      [ScopeType.Read]: "rprtl:r" /* scope.Report.ReadLocal */,
      [ScopeType.Update]: "rprtl:u" /* scope.Report.UpdateLocal */,
      [ScopeType.Delete]: "rprtl:d" /* scope.Report.DeleteLocal */
    }
  }]
}, {
  name: Module.FinancialLocal,
  permissions: [{
    label: 'PERMISSION_FINANCIAL_LOCAL',
    scopes: {
      [ScopeType.Allow]: "evt:f" /* scope.Event.ManageFinances */
    }
  }]
}, {
  name: Module.RoomManagementLocal,
  permissions: [{
    label: 'PERMISSION_ROOM_MANAGEMENT_LOCAL',
    scopes: {
      [ScopeType.Create]: "rml:c" /* scope.RoomManagement.CreateLocal */,
      [ScopeType.Read]: "rml:r" /* scope.RoomManagement.ReadLocal */,
      [ScopeType.Update]: "rml:u" /* scope.RoomManagement.UpdateLocal */,
      [ScopeType.Delete]: "rml:d" /* scope.RoomManagement.DeleteLocal */
    }
  }, {
    label: 'PERMISSION_ROOM_MANAGEMENT_APPROVE_LOCAL',
    scopes: {
      [ScopeType.Allow]: "rml:ab" /* scope.RoomManagement.ApproveBookingLocal */
    }
  }]
}, {
  name: Module.Azavista2,
  permissions: [{
    label: 'PERMISSION_USE_WEBAPP',
    scopes: {
      [ScopeType.Allow]: "az2:w" /* scope.Azavista2.UseWebapp */
    }
  }, {
    label: 'PERMISSION_USE_API',
    scopes: {
      [ScopeType.Allow]: "az2:a" /* scope.Azavista2.UseAPI */
    }
  }]
}, {
  name: Module.GenericTeam,
  permissions: [{
    label: 'PERMISSION_GENERIC_TEAM',
    scopes: {
      [ScopeType.Allow]: "gtm:g" /* scope.GenericTeam.GenericTeam */
    }
  }, {
    label: 'PERMISSION_INVITE_GENERIC_TEAM',
    scopes: {
      [ScopeType.Allow]: "gtm:invite" /* scope.GenericTeam.InviteGenericTeam */
    }
  }]
}, {
  name: Module.EventApp,
  permissions: [{
    label: 'PERMISSION_EVENT_APP',
    scopes: {
      [ScopeType.Create]: "eva:c" /* scope.GlobalEventApp.Create */,
      [ScopeType.Read]: "eva:r" /* scope.GlobalEventApp.Read */,
      [ScopeType.Update]: "eva:u" /* scope.GlobalEventApp.Update */,
      [ScopeType.Delete]: "eva:d" /* scope.GlobalEventApp.Delete */
    }
  }]
}, {
  name: Module.Global,
  permissions: [{
    label: 'PERMISSION_GLOBAL_ADMIN',
    scopes: {
      [ScopeType.Allow]: "a" /* scope.Global.Admin */
    }
  }]
}, {
  name: Module.EventWorkflow,
  permissions: [{
    label: 'PERMISSION_EVENT_WORKFLOW',
    scopes: {
      [ScopeType.Allow]: "evt:w" /* scope.Event.Workflow */
    }
  }]
}];
const getModuleList = () => {
  return exports.ModuleList;
};
exports.getModuleList = getModuleList;
const parseScopes = permissionDef => {
  const allScopes = [];
  const readonlyScopes = [];
  permissionDef.permissions.forEach(permission => {
    Object.keys(permission.scopes).forEach(scopeType => {
      allScopes.push(permission.scopes[scopeType]);
      if (scopeType === ScopeType.Read) {
        readonlyScopes.push(permission.scopes[scopeType]);
      }
    });
  });
  return {
    allScopes: allScopes,
    readonlyScopes: readonlyScopes
  };
};
const getModuleSelection = currentScopes => {
  return exports.ModulePermissions.map(modulePermission => {
    const {
      allScopes,
      readonlyScopes
    } = parseScopes(modulePermission);
    let selectedType = ScopeSelectionType.Custom;
    const anyScopeSelected = allScopes.find(s => currentScopes.includes(s));
    if (!anyScopeSelected) {
      selectedType = ScopeSelectionType.Disabled;
    } else {
      const missingScope = allScopes.find(s => !currentScopes.includes(s));
      if (!missingScope) {
        selectedType = ScopeSelectionType.All;
      } else if (readonlyScopes.length) {
        const missingReadonlyScope = readonlyScopes.find(s => !currentScopes.includes(s));
        if (!missingReadonlyScope) {
          const nonReadonlyScope = currentScopes.find(s => allScopes.includes(s) && !readonlyScopes.includes(s));
          if (!nonReadonlyScope) {
            selectedType = ScopeSelectionType.ReadOnly;
          }
        }
      }
    }
    return {
      name: modulePermission.name,
      selected_type: selectedType
    };
  });
};
exports.getModuleSelection = getModuleSelection;
const getModuleCustomScope = (moduleName, currentScopes) => {
  const permissionDef = exports.ModulePermissions.find(modulePermission => {
    return modulePermission.name === moduleName;
  });
  if (!permissionDef) {
    return [];
  }
  return permissionDef.permissions.map(permission => {
    const scopes = {};
    Object.values(ScopeType).forEach(scopeType => {
      if (!permission.scopes[scopeType]) {
        scopes[scopeType] = null;
      } else {
        scopes[scopeType] = {
          scope: permission.scopes[scopeType],
          selected: currentScopes.includes(permission.scopes[scopeType])
        };
      }
    });
    return {
      label: permission.label,
      scopes: scopes
    };
  });
};
exports.getModuleCustomScope = getModuleCustomScope;
const setModuleSelection = (currentScopes, moduleName, selectionType) => {
  const permissionDef = exports.ModulePermissions.find(modulePermission => {
    return modulePermission.name === moduleName;
  });
  if (!permissionDef || selectionType === ScopeSelectionType.Custom) {
    return currentScopes;
  }
  const {
    allScopes,
    readonlyScopes
  } = parseScopes(permissionDef);
  let filteredScopes = [];
  if (selectionType === ScopeSelectionType.Disabled) {
    filteredScopes = currentScopes.filter(s => {
      return !allScopes.includes(s);
    });
  } else if (selectionType === ScopeSelectionType.All) {
    filteredScopes = [...currentScopes, ...allScopes];
    // Remove duplicates.
    filteredScopes = [...new Set(filteredScopes)];
  } else if (selectionType === ScopeSelectionType.ReadOnly) {
    filteredScopes = [...currentScopes, ...readonlyScopes];
    // Remove duplicates.
    filteredScopes = [...new Set(filteredScopes)];
    // Remove non-readonly scopes.
    filteredScopes = filteredScopes.filter(s => {
      return !allScopes.includes(s) || readonlyScopes.includes(s);
    });
  }
  return filteredScopes;
};
exports.setModuleSelection = setModuleSelection;
// You need to add a scope here and update a test case
// when a new one is added.
exports.scopeList = ["az2:w" /* scope.Azavista2.UseWebapp */, "az2:a" /* scope.Azavista2.UseAPI */, "crm:c" /* scope.CRM.Create */, "crm:u" /* scope.CRM.Update */, "crm:r" /* scope.CRM.Read */, "crm:d" /* scope.CRM.Delete */, "crm:x" /* scope.CRM.ExportSpreadsheet */, "crm:v" /* scope.CRM.View */, "cf:c" /* scope.ContactField.Create */, "cf:u" /* scope.ContactField.Update */, "cf:r" /* scope.ContactField.Read */, "cf:d" /* scope.ContactField.Delete */, "of:c" /* scope.OrganizationField.Create */, "of:u" /* scope.OrganizationField.Update */, "of:r" /* scope.OrganizationField.Read */, "of:d" /* scope.OrganizationField.Delete */, "ctp:c" /* scope.CRMEmail.CreateTemplate */, "ctp:u" /* scope.CRMEmail.UpdateTemplate */, "ctp:r" /* scope.CRMEmail.ReadTemplate */, "ctp:d" /* scope.CRMEmail.DeleteTemplate */, "ctp:p" /* scope.CRMEmail.PublishTemplate */, "cmc:c" /* scope.CRMEmail.CreateCampaign */, "cmc:u" /* scope.CRMEmail.UpdateCampaign */, "cmc:r" /* scope.CRMEmail.ReadCampaign */, "cmc:d" /* scope.CRMEmail.DeleteCampaign */, "mailc:s" /* scope.CRMEmail.SendMail */, "asc:c" /* scope.CRMEmail.CreateAsset */, "asc:u" /* scope.CRMEmail.UpdateAsset */, "asc:r" /* scope.CRMEmail.ReadAsset */, "asc:d" /* scope.CRMEmail.DeleteAsset */, "cmt:c" /* scope.CRMEmail.CreateCampaignType */, "cmt:u" /* scope.CRMEmail.UpdateCampaignType */, "cmt:r" /* scope.CRMEmail.ReadCampaignType */, "cmt:d" /* scope.CRMEmail.DeleteCampaignType */, "evetp:c" /* scope.GlobalEventEmailTemplate.CreateTemplate */, "evetp:u" /* scope.GlobalEventEmailTemplate.UpdateTemplate */, "evetp:r" /* scope.GlobalEventEmailTemplate.ReadTemplate */, "evetp:d" /* scope.GlobalEventEmailTemplate.DeleteTemplate */, "evetp:p" /* scope.GlobalEventEmailTemplate.PublishTemplate */, "evasc:c" /* scope.GlobalEventEmailTemplate.CreateAsset */, "evasc:u" /* scope.GlobalEventEmailTemplate.UpdateAsset */, "evasc:r" /* scope.GlobalEventEmailTemplate.ReadAsset */, "evasc:d" /* scope.GlobalEventEmailTemplate.DeleteAsset */, "evt:c" /* scope.Event.Create */, "evt:u" /* scope.Event.Update */, "evt:r" /* scope.Event.Read */, "evt:l" /* scope.Event.List */, "evt:d" /* scope.Event.Delete */, "evt:cp" /* scope.Event.Copy */, "evt:f" /* scope.Event.ManageFinances */, "evt:x" /* scope.Event.Cancel */, "evt:s" /* scope.Event.UpdateSettings */, "evt:v" /* scope.Event.View */, "evt:a" /* scope.Event.EventAdmin */, "evt:w" /* scope.Event.Workflow */, "ef:c" /* scope.EventField.Create */, "ef:u" /* scope.EventField.Update */, "ef:r" /* scope.EventField.Read */, "ef:d" /* scope.EventField.Delete */, "lef:c" /* scope.EventField.CreateLocal */, "lef:u" /* scope.EventField.UpdateLocal */, "lef:d" /* scope.EventField.DeleteLocal */, "par:c" /* scope.Participant.Create */, "par:u" /* scope.Participant.Update */, "par:d" /* scope.Participant.Delete */, "par:x" /* scope.Participant.ExportSpreadsheet */, "par:i" /* scope.Participant.Impersonate */, "par:t" /* scope.Participant.ManageTeam */, "par:v" /* scope.Participant.View */, "eng:r" /* scope.EngagementApp.ReadSettings */, "eng:u" /* scope.EngagementApp.UpdateSettings */, "epf:c" /* scope.ParticipantField.Create */, "epf:u" /* scope.ParticipantField.Update */, "epf:r" /* scope.ParticipantField.Read */, "epf:d" /* scope.ParticipantField.Delete */, "evp:c" /* scope.EventPage.Create */, "evp:u" /* scope.EventPage.Update */, "evp:r" /* scope.EventPage.Read */, "evp:d" /* scope.EventPage.Delete */, "evp:p" /* scope.EventPage.Publish */, "ast:c" /* scope.EventPage.CreateAsset */, "ast:u" /* scope.EventPage.UpdateAsset */, "ast:r" /* scope.EventPage.ReadAsset */, "ast:d" /* scope.EventPage.DeleteAsset */, "etp:c" /* scope.EventEmail.CreateTemplate */, "etp:u" /* scope.EventEmail.UpdateTemplate */, "etp:r" /* scope.EventEmail.ReadTemplate */, "etp:d" /* scope.EventEmail.DeleteTemplate */, "etp:p" /* scope.EventEmail.PublishTemplate */, "cmp:c" /* scope.EventEmail.CreateCampaign */, "cmp:u" /* scope.EventEmail.UpdateCampaign */, "cmp:r" /* scope.EventEmail.ReadCampaign */, "cmp:d" /* scope.EventEmail.DeleteCampaign */, "mail:s" /* scope.EventEmail.SendMail */, "asc:c" /* scope.EventEmail.CreateAsset */, "asc:u" /* scope.EventEmail.UpdateAsset */, "asc:r" /* scope.EventEmail.ReadAsset */, "asc:d" /* scope.EventEmail.DeleteAsset */, "thm:c" /* scope.Theme.Create */, "thm:u" /* scope.Theme.Update */, "thm:r" /* scope.Theme.Read */, "thm:d" /* scope.Theme.Delete */, "att:c" /* scope.Theme.CreateAsset */, "att:u" /* scope.Theme.UpdateAsset */, "att:r" /* scope.Theme.ReadAsset */, "att:d" /* scope.Theme.DeleteAsset */, "act:c" /* scope.Activity.Create */, "act:u" /* scope.Activity.Update */, "act:r" /* scope.Activity.Read */, "act:d" /* scope.Activity.Delete */, "stg:c" /* scope.Stage.Create */, "stg:u" /* scope.Stage.Update */, "stg:r" /* scope.Stage.Read */, "stg:d" /* scope.Stage.Delete */, "gprc:c" /* scope.GlobalParticipantProcess.Create */, "gprc:ul" /* scope.GlobalParticipantProcess.Update */, "gprc:r" /* scope.GlobalParticipantProcess.Read */, "gprc:d" /* scope.GlobalParticipantProcess.Delete */, "gprc:u" /* scope.GlobalParticipantProcess.UpdateAndControl */, "gprc:p" /* scope.GlobalParticipantProcess.Pause */, "gprc:i" /* scope.GlobalParticipantProcess.Interrupt */, "prc:c" /* scope.ParticipantProcess.Create */, "prc:ul" /* scope.ParticipantProcess.Update */, "prc:r" /* scope.ParticipantProcess.Read */, "prc:d" /* scope.ParticipantProcess.Delete */, "prc:u" /* scope.ParticipantProcess.UpdateAndControl */, "prc:p" /* scope.ParticipantProcess.Pause */, "prc:i" /* scope.ParticipantProcess.Interrupt */, "cp:c" /* scope.ContactProcess.Create */, "cp:ul" /* scope.ContactProcess.Update */, "cp:r" /* scope.ContactProcess.Read */, "cp:d" /* scope.ContactProcess.Delete */, "cp:u" /* scope.ContactProcess.UpdateAndControl */, "cp:p" /* scope.ContactProcess.Pause */, "cp:i" /* scope.ContactProcess.Interrupt */, "op:c" /* scope.OrganizationProcess.Create */, "op:ul" /* scope.OrganizationProcess.Update */, "op:r" /* scope.OrganizationProcess.Read */, "op:d" /* scope.OrganizationProcess.Delete */, "op:u" /* scope.OrganizationProcess.UpdateAndControl */, "op:p" /* scope.OrganizationProcess.Pause */, "op:i" /* scope.OrganizationProcess.Interrupt */, "gevtp:c" /* scope.GlobalEventProcess.Create */, "gevtp:ul" /* scope.GlobalEventProcess.Update */, "gevtp:r" /* scope.GlobalEventProcess.Read */, "gevtp:d" /* scope.GlobalEventProcess.Delete */, "gevtp:u" /* scope.GlobalEventProcess.UpdateAndControl */, "gevtp:p" /* scope.GlobalEventProcess.Pause */, "gevtp:i" /* scope.GlobalEventProcess.Interrupt */, "evtp:c" /* scope.EventProcess.Create */, "evtp:ul" /* scope.EventProcess.Update */, "evtp:r" /* scope.EventProcess.Read */, "evtp:d" /* scope.EventProcess.Delete */, "evtp:u" /* scope.EventProcess.UpdateAndControl */, "evtp:p" /* scope.EventProcess.Pause */, "evtp:i" /* scope.EventProcess.Interrupt */, "int:c" /* scope.Integration.Create */, "int:u" /* scope.Integration.Update */, "int:r" /* scope.Integration.Read */, "int:d" /* scope.Integration.Delete */, "ser:c" /* scope.EventSeries.Create */, "ser:u" /* scope.EventSeries.Update */, "ser:r" /* scope.EventSeries.Read */, "ser:d" /* scope.EventSeries.Delete */, "ser:p" /* scope.EventSeries.Publish */, "fin:c" /* scope.Financial.Create */, "fin:u" /* scope.Financial.Update */, "fin:r" /* scope.Financial.Read */, "fin:d" /* scope.Financial.Delete */, "prf:c" /* scope.ProfilePage.Create */, "prf:u" /* scope.ProfilePage.Update */, "prf:r" /* scope.ProfilePage.Read */, "prf:d" /* scope.ProfilePage.Delete */, "rmm:c" /* scope.RoomManagement.Create */, "rmm:u" /* scope.RoomManagement.Update */, "rmm:r" /* scope.RoomManagement.Read */, "rmm:d" /* scope.RoomManagement.Delete */, "rmm:ab" /* scope.RoomManagement.ApproveBooking */, "rml:c" /* scope.RoomManagement.CreateLocal */, "rml:u" /* scope.RoomManagement.UpdateLocal */, "rml:r" /* scope.RoomManagement.ReadLocal */, "rml:d" /* scope.RoomManagement.DeleteLocal */, "rml:ab" /* scope.RoomManagement.ApproveBookingLocal */, "rprt:c" /* scope.Report.Create */, "rprt:u" /* scope.Report.Update */, "rprt:r" /* scope.Report.Read */, "rprt:d" /* scope.Report.Delete */, "rprtl:c" /* scope.Report.CreateLocal */, "rprtl:u" /* scope.Report.UpdateLocal */, "rprtl:r" /* scope.Report.ReadLocal */, "rprtl:d" /* scope.Report.DeleteLocal */, "a" /* scope.Global.Admin */, "gtm:g" /* scope.GenericTeam.GenericTeam */, "gtm:invite" /* scope.GenericTeam.InviteGenericTeam */, "prj:c" /* scope.Project.Create */, "prj:u" /* scope.Project.Update */, "prj:r" /* scope.Project.Read */, "prj:d" /* scope.Project.Delete */, "tsk:c" /* scope.Task.Create */, "tsk:u" /* scope.Task.Update */, "tsk:r" /* scope.Task.Read */, "tsk:d" /* scope.Task.Delete */, "eva:c" /* scope.GlobalEventApp.Create */, "eva:u" /* scope.GlobalEventApp.Update */, "eva:r" /* scope.GlobalEventApp.Read */, "eva:d" /* scope.GlobalEventApp.Delete */, "eeva:c" /* scope.EventEventApp.Create */, "eeva:u" /* scope.EventEventApp.Update */, "eeva:r" /* scope.EventEventApp.Read */, "eeva:d" /* scope.EventEventApp.Delete */, "se:c" /* scope.SystemEmail.Create */, "se:u" /* scope.SystemEmail.Update */, "se:r" /* scope.SystemEmail.Read */, "se:d" /* scope.SystemEmail.Delete */, "umu:c" /* scope.User.Create */, "umu:r" /* scope.User.Read */, "umu:u" /* scope.User.Update */, "umu:d" /* scope.User.Delete */, "umu:a" /* scope.User.Assign */, "umt:c" /* scope.Team.Create */, "umt:r" /* scope.Team.Read */, "umt:u" /* scope.Team.Update */, "umt:d" /* scope.Team.Delete */, "umt:a" /* scope.Team.Assign */, "umr:r" /* scope.Role.Read */, "umr:a" /* scope.Role.Assign */, "uma:c" /* scope.ApiClient.Create */, "uma:r" /* scope.ApiClient.Read */, "uma:u" /* scope.ApiClient.Update */, "uma:d" /* scope.ApiClient.Delete */, "uma:a" /* scope.ApiClient.Assign */];
